import { render, staticRenderFns } from "./EftPaymentDetails.vue?vue&type=template&id=feced1aa&scoped=true&"
import script from "./EftPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./EftPaymentDetails.vue?vue&type=script&lang=js&"
import style0 from "./EftPaymentDetails.vue?vue&type=style&index=0&id=feced1aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feced1aa",
  null
  
)

export default component.exports